export default __webpack_public_path__ + "static/Carousel-InstantPreview@2x-0454730f024a4be933ef777e439cf0af.png";